function Component({ children, label }) {
  return (
    <div className="d-flex flex-row align-items-center gap-3">
      <div className="label text-nowrap">{label}</div>
      {children}
    </div>
  )
}

export default Component;
